module.exports = __webpack_public_path__ + "static/media/icon_arrow-up_green.97ae6c0f.svg";